/**
 * TODO: remove this file after legacy libraries rewriting (@yola/yousersjs)
 *       libraries should be published as a bundle, not a source code
 */
import axios from 'axios';

export default axios;
